import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BannerComponent } from '../banner/banner.component';
import { CardComponent } from '../card/card.component';
import { CardMoradoresComponent } from '../card-moradores/card-moradores.component';
import { NoticiaComponent } from '../noticias/noticia.component';
import { CarouselComponent } from '../carousel/carousel.component';
import { GoogleAnalyticsService } from '../../services/google-analytics/google-analytics.service';
import { AgendaComponent } from "../agenda/agenda.component";

@Component({
    selector: 'app-container',
    standalone: true,
    imports: [
    CommonModule,
    BannerComponent,
    CardComponent,
    CardMoradoresComponent,
    NoticiaComponent,
    CarouselComponent,
    AgendaComponent
],
    templateUrl: './container.component.html',
    styleUrls: ['./container.component.scss']
})
export class ContainerComponent {
    constructor(private googleAnalyticsService: GoogleAnalyticsService) {}
}
